<template>
  <DeviceSetupSection>
    <template v-slot:left>
      <PageContainer
        :class="$style.container"
      >
        <template v-slot:body>
          <Container>
            <HeadingLarge>
              {{ selectedInstall.header }}
            </HeadingLarge>
            <TerminalSetupInstructions
              v-if="!onLastStep"
              :copyWell="copyWell"
              :instructions="selectedInstall.subheader"
              :label="selectedInstall.label"
              :showCommand="currentStep === 2"
            />
            <DeviceSetupSuccess v-else />
          </Container>
        </template>

        <template v-slot:footer>
          <Container>
            <ButtonGroupSave
              :isFullWidth="false"
              :primaryButtonProps="primaryButtonProps"
              :secondaryButtonProps="secondaryButtonProps"
              @primaryAction="handleNext"
              @secondaryAction="secondaryAction"
            />
          </Container>
        </template>
      </PageContainer>
    </template>
    <template v-slot:right>
      <div
        :class="[$style.image, $style.center]"
        :style="{ backgroundImage }"
      />
    </template>
  </DeviceSetupSection>
</template>

<script>
import {
  ButtonGroupSave,
  Container,
  HeadingLarge,
  PageContainer,
} from '@jumpcloud/ui-components';
import { guidedSetupInstallTypes } from 'client/Discover/components/GuidedSetup/GuidedSetupSettings';
import CreateSystemMixin from 'client/systems/CreateSystemMixin';
import DeviceSetupSection from 'client/Discover/components/GuidedSetup/DeviceSetupSection.vue';
import DeviceSetupSuccess from 'client/Discover/components/GuidedSetup/DeviceSetupSuccess.vue';
import GuidedSetupMixin from 'client/Discover/components/GuidedSetup/mixins/GuidedSetupMixin';
import TerminalSetupInstructions from 'client/Discover/components/GuidedSetup/TerminalSetupInstructions.vue';

export default {
  name: 'TerminalSetup',

  components: {
    ButtonGroupSave,
    Container,
    DeviceSetupSection,
    DeviceSetupSuccess,
    HeadingLarge,
    PageContainer,
    TerminalSetupInstructions,
  },

  mixins: [
    CreateSystemMixin,
    GuidedSetupMixin,
  ],

  computed: {
    copyWell() {
      return this.selectedInstall.value === guidedSetupInstallTypes.terminal
        ? this.copyWellTerminal : this.copyWellPowershell;
    },
  },
};
</script>

<style scoped module>
@import './css/guided-setup.css';
</style>>
